const resolveRental = (rental) => {
  if (!rental) return null;
  if (rental.vehicle?.svid) return rental.vehicle.svid;
  if (rental.id) return `${rental.id}`;
  return null;
};

export default resolveRental;
